/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Global Enter-key handler for discount inputs: prevent form submit and apply discount
  (function(){
    function handleDiscountEnter(e){
      try{
        const target = e.target;
        if(!target || !target.matches || !target.matches('[data-discount-input]')) return;
        if(e.code === 'Enter' || e.keyCode === 13){
          e.preventDefault();
          const code = (target.value || '').trim();
          target.value = '';
          if(!code) return;
          const cartComp = document.querySelector('cart-items');
          if(cartComp && typeof cartComp.applyDiscount === 'function'){
            cartComp.applyDiscount(code);
            return;
          }
          fetch(window.theme.routes.cart_update_url,{
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: code })
          }).then(()=>{ document.dispatchEvent(new CustomEvent('theme:cart:refresh')); }).catch(()=>{});
        }
      }catch(err){console.error(err)}
    }
    document.addEventListener('keydown', handleDiscountEnter, true);
  })();
  
  // JudgeMe stars badge - reorder elemnts
  // try reordering as soon as possible, retry every 100ms until all badges processed
  (function tryReorderRepeatedly() {
    var interval = setInterval(function() {
      var badges = document.querySelectorAll('.jdgm-widget .jdgm-prev-badge');
      var foundUnprocessed = false;

      badges.forEach(function(badge) {
        if (badge.dataset.jdgmReordered) return;
        var avg = badge.querySelector('.jdgm-avg-rating');
        var stars = badge.querySelector('.jdgm-prev-badge__stars');
        var count = badge.querySelector('.jdgm-rating-count');
        if (!avg) return; // wait until avg rating exists

        // perform reorder
        try {
          if (avg && stars.parentNode && avg !== stars.previousElementSibling) {
            stars.parentNode.insertBefore(avg, stars);
          }
          if (count && stars.parentNode && count !== stars.nextElementSibling) {
            stars.parentNode.insertBefore(count, stars.nextSibling);
          }
          badge.dataset.jdgmReordered = '1';
        } catch (e) {
          console.error('jdgm reorder error', e);
        }
      });

      // Check if any remaining badges still need processing
      var remaining = Array.from(document.querySelectorAll('.jdgm-widget .jdgm-prev-badge')).some(function(b) {
        return !b.dataset.jdgmReordered && b.querySelector('.jdgm-prev-badge__stars');
      });

      if (!remaining) {
        clearInterval(interval);
        // console.log('Judge.me reorder: completed, interval cleared'); // comment out for testing
      }
    }, 100);
  })();

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();